import Request from "@/libraries/request.js";
import Const from "@/const/const.js";

export default {
  BaseURL: "/customer/",
  async get(url = null) {
    const customers = await Request.getAsync(url);
    let data = {};
    if (customers.data.status) {
      data = customers.data.data;
    } else {
      throw new Error(customers.data.msg);
    }
    return data;
  },
  async get_customer(supId = null) {
    if (supId == null) {
      throw new Error("Supplier ID not found.");
    }
    const url = this.BaseURL + supId;
    const data = await this.get(url);
    return data[0];
  },
  async get_all_customer() {
    return await this.get(this.BaseURL);
  }
};




// WEBPACK FOOTER //
// ./src/model/customer_model.js